var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInactiveScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 92,
    viewBox: "0 0 84 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.9219 49.375C78.9219 48.3594 78.5156 47.3438 77.7031 46.5313C76.8906 45.7188 75.875 45.3125 74.8594 45.3125H28.1406C27.125 45.3125 26.1094 45.7188 25.2969 46.5313C24.4844 47.3438 24.0781 48.3594 24.0781 49.375V81.875H78.9219V49.375Z",
    fill: "#474545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8594 49.375H28.1406V77.8125H74.8594V49.375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66 81.875H1V83.9062H66V81.875Z",
    fill: "#EFF4F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84 83.9062C84 84.9219 83.5938 85.9375 82.7812 86.75C81.9688 87.5625 80.9531 87.9688 79.9375 87.9688H23.0625C22.0469 87.9688 21.0312 87.5625 20.2188 86.75C19.4063 85.9375 19 84.9219 19 83.9062H84Z",
    fill: "#DFE3E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5938 83.9062H27.4062L25.375 81.875H41.625L39.5938 83.9062Z",
    fill: "#5E5C5C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8594 73.75H28.1406V77.8125H74.8594V73.75Z",
    fill: "#DFE3E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8594 49.375H28.1406V53.4375H74.8594V49.375Z",
    fill: "#DFE3E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8281 62.5781H70.7969V64.6094H72.8281V62.5781Z",
    fill: "#474545"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7656 62.5781H58.6094V64.6094H68.7656V62.5781Z",
    fill: "#474545"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2031 62.5781H30.1719V64.6094H32.2031V62.5781Z",
    fill: "#474545"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3906 62.5781H34.2344V64.6094H44.3906V62.5781Z",
    fill: "#474545"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 71.7188C55.9873 71.7188 59.625 68.0811 59.625 63.5938C59.625 59.1064 55.9873 55.4688 51.5 55.4688C47.0127 55.4688 43.375 59.1064 43.375 63.5938C43.375 68.0811 47.0127 71.7188 51.5 71.7188Z",
    fill: "#F4608A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4531 73.75H46.4219V75.7812H48.4531V73.75Z",
    fill: "#474545"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5156 73.75H50.4844V75.7812H52.5156V73.75Z",
    fill: "#474545"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5781 73.75H54.5469V75.7812H56.5781V73.75Z",
    fill: "#474545"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2578 61.2578L53.8359 59.8359L51.5 62.1719L49.1641 59.8359L47.7422 61.2578L50.0781 63.5938L47.7422 65.9297L49.1641 67.3516L51.5 65.0156L53.8359 67.3516L55.2578 65.9297L52.9219 63.5938L55.2578 61.2578Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7344 40.2344H64.7031C64.7031 32.9219 58.8125 27.0312 51.5 27.0312C44.1875 27.0312 38.2969 32.9219 38.2969 40.2344H36.2656C36.2656 31.8047 43.0703 25 51.5 25C59.9297 25 66.7344 31.8047 66.7344 40.2344Z",
    fill: "#474545"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6719 40.2344H60.6406C60.6406 35.1562 56.5781 31.0938 51.5 31.0938C46.4219 31.0938 42.3594 35.1562 42.3594 40.2344H40.3281C40.3281 34.0391 45.3047 29.0625 51.5 29.0625C57.6953 29.0625 62.6719 34.0391 62.6719 40.2344Z",
    fill: "#474545"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6094 40.2344H56.5781C56.5781 37.3906 54.3438 35.1562 51.5 35.1562C48.6562 35.1562 46.4219 37.3906 46.4219 40.2344H44.3906C44.3906 36.2734 47.5391 33.125 51.5 33.125C55.4609 33.125 58.6094 36.2734 58.6094 40.2344Z",
    fill: "#474545"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5 43.2812C49.7734 43.2812 48.4531 41.9609 48.4531 40.2344C48.4531 38.5078 49.7734 37.1875 51.5 37.1875C53.2266 37.1875 54.5469 38.5078 54.5469 40.2344C54.5469 41.9609 53.2266 43.2812 51.5 43.2812ZM51.5 39.2188C50.8906 39.2188 50.4844 39.625 50.4844 40.2344C50.4844 40.8438 50.8906 41.25 51.5 41.25C52.1094 41.25 52.5156 40.8438 52.5156 40.2344C52.5156 39.625 52.1094 39.2188 51.5 39.2188Z",
    fill: "#474545"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveScreen);
export default __webpack_public_path__ + "static/media/InactiveScreen.4d82901c29901bf2e6b0b86f53aacc24.svg";
export { ForwardRef as ReactComponent };